var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfetti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1443,
    height: 900,
    viewBox: "0 0 1443 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_955_35060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.727 17.0981L506.354 16.8064L505.599 36.0832L514.971 36.3749L515.727 17.0981Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.344 317.158L418.915 312.129L409.765 316.969L413.194 321.998L422.344 317.158Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.584 421.641L175.414 416.368L169.4 422.879L176.57 428.151L182.584 421.641Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.964 314.162L583.28 311.289L572.808 299.883L568.492 302.756L578.964 314.162Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.66 443.108L1152.08 440.082L1148.81 430.57L1142.39 433.596L1145.66 443.108Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.897 138.101L389.258 131.672L380.05 142.137L387.689 148.566L396.897 138.101Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.961 457.755L462.105 452.389L441.338 436.182L436.195 441.548L456.961 457.755Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1289.52 177.524L1290.9 170.725L1273.75 166.472L1272.37 173.27L1289.52 177.524Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.607 292.792L272.218 285.961L252.633 296.058L257.022 302.889L276.607 292.792Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1415.39 176.935L1419.72 171.788L1413.97 167.91L1409.64 173.057L1415.39 176.935Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.335 548.145L98.2734 545.523L86.4366 562.596L92.4979 565.217L104.335 548.145Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.007 875.095L621.321 870.974L607.098 858.759L602.784 862.88L617.007 875.095Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.97 634.397L1189.06 630.446L1184.62 627.977L1182.52 631.928L1186.97 634.397Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.781 337.014L919.862 330.951L904.832 340.555L910.751 346.617L925.781 337.014Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.106 392.922L482.607 388.461L469.778 372.936L463.277 377.397L476.106 392.922Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.311 44.6806L538.08 42.1562L533.743 35.8944L528.974 38.4187L533.311 44.6806Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.917 892.646L253.522 889.568L247.822 903.797L254.216 906.874L259.917 892.646Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.426 651.705L624.036 652.215L619.67 639.247L613.06 638.737L617.426 651.705Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.06 700.269L905.397 695.683L899.343 679.93L890.005 684.516L896.06 700.269Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6564 663.506L49.2375 659L35.2395 670.128L39.6584 674.634L53.6564 663.506Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.54 376.736L1225.75 373.565L1217.26 384.218L1222.05 387.389L1230.54 376.736Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.69 678.832L1406.58 670.754L1387.87 677.601L1393.98 685.679L1412.69 678.832Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.711 776.782L262.919 772.238H252.202L252.994 776.782H263.711Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.256 683.194L446.585 676.447L425.962 666.162L421.633 672.909L442.256 683.194Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.911 787.588L351.659 782.622L344.431 778.975L341.683 783.941L348.911 787.588Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400.96 219.274L1399.21 213.496L1386.64 212.541L1388.39 218.319L1400.96 219.274Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1154.58 688.469L1159.22 685.391L1149.12 674.993L1144.48 678.071L1154.58 688.469Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5388 719.03L90.1323 716.835L80.9632 727.426L85.3697 729.621L94.5388 719.03Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.128 319.73L863.87 313.921L857.375 308.166L850.633 313.975L857.128 319.73Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.448 714.943L948.677 706.711L926.192 710.396L929.962 718.627L952.448 714.943Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.087 696.96L825.553 691.148L810.144 695.334L814.679 701.146L830.087 696.96Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.22 586.918L289.303 581.575L282.701 577.972L279.618 583.314L286.22 586.918Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.9 292.69L1093.26 284.493L1071.46 290.068L1075.1 298.265L1096.9 292.69Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M896.613 617.234L891.669 613.445L883.208 622.721L888.152 626.51L896.613 617.234Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.133 207.506L222.755 201.213L203.681 195.146L202.059 201.439L221.133 207.506Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.297 215.054L288.373 210.386L282.003 226.389L290.927 231.058L297.297 215.054Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.67 418.003L1218.51 411.158L1207.12 419.639L1214.27 426.484L1225.67 418.003Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.958 157.703L676.704 151.191L662.702 150.281L660.957 156.793L674.958 157.703Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.37 66.2039L744.45 61.1958L735.479 68.0902L740.4 73.0983L749.37 66.2039Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.48976 727.329L4.42017 724.16L0.438193 717.113L-5.47174 720.281L-1.48976 727.329Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.337 93.7426L440.011 94.2842L441.031 87.8428L435.356 87.3012L434.337 93.7426Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.326 782.184L926.536 776.429L909.826 763.907L904.615 769.662L921.326 782.184Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5156 599.759L71.4255 596.719L64.5648 608.659L69.6548 611.699L76.5156 599.759Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.113 126.389L322.52 119.568L312.72 124.404L317.313 131.225L327.113 126.389Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.469 620.716L796.925 616.521L790.716 614.342L789.261 618.537L795.469 620.716Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.45 576.469L606.848 573.57L602.14 580.481L606.741 583.381L611.45 576.469Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.966 465.247L921.642 457.538L895.553 448.032L893.877 455.742L919.966 465.247Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.63 844.104L1042.2 837.615L1034.07 834.314L1031.5 840.803L1039.63 844.104Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.107 705.143L642.457 701.194L625.805 690.09L623.456 694.039L640.107 705.143Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.257 472.854L704.459 468.631L696.812 473.806L700.61 478.029L708.257 472.854Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.299 97.8073L665.777 95.8176L655.887 110.396L661.409 112.385L671.299 97.8073Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.439 646.215L966.564 639.803L958.585 640.92L958.46 647.332L966.439 646.215Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.37 571.514L1009.49 565.892L997.542 573.033L1002.42 578.655L1014.37 571.514Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.814 117.309L731.634 109.861L719.718 115.991L725.898 123.439L737.814 117.309Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.16 712.07L1079.95 712.251L1075.08 699.276L1069.29 699.094L1074.16 712.07Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.004 398.026L954.314 396.026L952.513 406.173L960.203 408.174L962.004 398.026Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.53 351.974L268.864 344.214L261.533 346.946L267.2 354.705L274.53 351.974Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.092 699.058L400.631 693.128L390.685 688.226L388.146 694.157L398.092 699.058Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.905 157.029L166.882 150.264L151.842 138.921L144.865 145.687L159.905 157.029Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.435 405.411L399.106 400.341L397.469 417.049L407.799 422.119L409.435 405.411Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1391.73 485.925L1383.92 477.387L1366.47 483.018L1374.29 491.556L1391.73 485.925Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.572 843.602L918.009 837.842L898.937 829.625L896.5 835.385L915.572 843.602Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.209 177.658L148.024 172.563L135.128 176.398L138.313 181.493L151.209 177.658Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1190.9 665.394L1189.92 657.132L1172.01 659.934L1172.98 668.195L1190.9 665.394Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.764 694.503L282.56 694.756L278.042 674.975L270.247 674.722L274.764 694.503Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.61 728.298L571.852 723.042L561.276 713.147L555.034 718.403L565.61 728.298Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.867 202.311L852.881 196.57L835.614 209.062L840.6 214.803L857.867 202.311Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1411.97 455.948L1418.47 454.247L1411.5 439.646L1405.01 441.347L1411.97 455.948Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.67 524.663L1017.3 523.758L1015.23 533.288L1021.6 534.193L1023.67 524.663Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.84412 711.169L4.54126 706.295L-8.15119 710.071L-6.84834 714.946L5.84412 711.169Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.026 363.237L743.723 357.387L727.678 363.664L728.982 369.514L745.026 363.237Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1013.03 682.438L1008.54 680.513L1003.58 689.951L1008.07 691.876L1013.03 682.438Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.57 405.711L1008.61 402.696L1000.43 419.86L1008.4 422.875L1016.57 405.711Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.354 474.544L153.619 469.853L142.204 459.153L135.938 463.844L147.354 474.544Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7562 851.995L32.1709 851.367L27.8756 863.507L33.4609 864.134L37.7562 851.995Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.945 741.421L692.169 737.628L679.342 727.187L675.118 730.98L687.945 741.421Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.37 765.854L1124.16 762.755L1116.23 754.684L1112.44 757.783L1120.37 765.854Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.391 734.318L868.233 729.796L863.785 731.008L865.942 735.529L870.391 734.318Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.141 297.031L969.443 289.299L944.233 289.692L943.931 297.424L969.141 297.031Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.411 418.125L515.551 414.136L507.609 428.518L515.469 432.506L523.411 418.125Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.993 673.107L536.771 666.331L520.984 671.134L524.205 677.91L539.993 673.107Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.44 617.655L1179.9 616.58L1175.83 600.656L1167.37 601.73L1171.44 617.655Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.199 899.324L884.478 892.421L875.254 895.276L877.976 902.178L887.199 899.324Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1397.95 673.68L1401.77 668.285L1392.6 663.03L1388.77 668.425L1397.95 673.68Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.757 559.427L657.502 554.293L641.673 543.073L636.928 548.207L652.757 559.427Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208.18 295.114L1203.68 290.826L1195.92 297.446L1200.43 301.734L1208.18 295.114Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.569 846.006L652.343 844.503L645.453 833.283L639.679 834.786L646.569 846.006Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.406 739.28L560.207 735.435L553.074 731.316L550.273 735.161L557.406 739.28Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.155 343.862L604.965 339.602L592.173 327.187L586.363 331.447L599.155 343.862Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1418.35 189.841L1413.52 184.91L1400.13 195.254L1404.96 200.186L1418.35 189.841Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3289 70.1244L36.1289 62.5632L24.8496 68.194L30.0495 75.7551L41.3289 70.1244Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.88 104.243L1078.22 98.626L1063.97 95.358L1061.63 100.975L1075.88 104.243Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.144 536.199L613.757 530.991L607.267 535.91L612.654 541.118L619.144 536.199Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.737 835.644L791.962 834.579L787.599 827.993L783.375 829.058L787.737 835.644Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.275 403.994L730.714 399.094L716.91 403.312L718.47 408.211L732.275 403.994Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.37 666.737L1179.15 665.131L1178.68 653.797L1169.9 655.403L1170.37 666.737Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1662 848.646L51.2192 842.677L42.7205 839.543L39.6674 845.511L48.1662 848.646Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.194 292.226L464.22 286.608L461.675 294.848L471.649 300.465L474.194 292.226Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.043 791.883L339.113 785.743L322.375 796.98L327.304 803.12L344.043 791.883Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1147.36 154.707L1150 149.322L1138.18 144.971L1135.54 150.356L1147.36 154.707Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107.82 275.049L1113.49 274.958L1110.7 267.8L1105.03 267.891L1107.82 275.049Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1258.27 619.463L1262.39 617.373L1256.19 610.601L1252.07 612.692L1258.27 619.463Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.86 273.642L429.857 269.24L423.273 276.797L428.276 281.199L434.86 273.642Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.61 371.14L1345.63 371.377L1345.63 362.969L1340.61 362.731L1340.61 371.14Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M800.447 832.756L793.711 826.994L787.308 832.533L794.044 838.295L800.447 832.756Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1157.21 150.238L1147.8 150.828L1143.06 172.904L1152.47 172.313L1157.21 150.238Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.502 72.0282L763.899 65.7056L753.822 58.5183L748.425 64.8409L758.502 72.0282Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.76 439.901L865.166 431.913L850.355 434.613L853.949 442.601L868.76 439.901Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.055 891.078L395.543 886.551L387.013 887.23L387.526 891.757L396.055 891.078Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.47 856.087L1233.5 851.768L1219.9 859.481L1222.87 863.8L1236.47 856.087Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.73 301.4L305.74 295.973L297.232 289.443L293.223 294.87L301.73 301.4Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M892.167 372.577L898.015 369.658L889.19 358.201L883.342 361.12L892.167 372.577Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.798 471.634L680.531 469.642L671.164 455.743L664.431 457.736L673.798 471.634Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.664 702.626L317.882 697.727L301.64 685.802L297.423 690.701L313.664 702.626Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.62 657.955L294.137 655.35L284.614 644.866L281.096 647.471L290.62 657.955Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205.29 269.361L1199.94 262.637L1183.52 273.551L1188.87 280.275L1205.29 269.361Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1157.26 341.878L1158.19 334.64L1140.61 327.89L1139.67 335.128L1157.26 341.878Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.42 673.966L839.893 666.371L833.22 668.839L839.748 676.434L846.42 673.966Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.636 735.373L662.378 729.533L651.684 725.448L649.942 731.288L660.636 735.373Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.43 894.619L1330.59 886.807L1316.4 884.039L1316.24 891.851L1330.43 894.619Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.754 115.453L318.374 114.281L316.247 103.5L310.627 104.672L312.754 115.453Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1121.03 134.621L1121.03 128.875L1103.59 131.302L1103.59 137.048L1121.03 134.621Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.435 630.863L626.887 624.489L610.338 622.268L611.886 628.642L628.435 630.863Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.01 250.405L111.785 242.691L87.0251 243.87L90.25 251.584L115.01 250.405Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.649 909.1L528.124 907.925L524.433 895.84L518.958 897.015L522.649 909.1Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.89 731.198L1164.58 726.461L1149.15 736.62L1152.45 741.357L1167.89 731.198Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.812 98.6673L744.996 92.9844L736.237 94.58L739.054 100.263L747.812 98.6673Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.473 462.688L189.426 462.45L187.772 455.319L182.819 455.556L184.473 462.688Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.57 470.965L1043.17 466.502L1037.73 467.219L1040.13 471.681L1045.57 470.965Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.952 578.855L135.89 575.8L133.043 584.42L140.105 587.476L142.952 578.855Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.921 625.408L438.913 624.052L442.75 640.076L451.758 641.432L447.921 625.408Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.2 820.424L601.099 815.719L592.936 822.738L598.038 827.443L606.2 820.424Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.98 835.796L1021.88 829.226L1011.78 838.556L1018.88 845.126L1028.98 835.796Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.474 196.359L457.569 190.612L441.843 184.195L440.748 189.942L456.474 196.359Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7445 145.348L44.4331 142.227L38.914 135.471L33.2254 138.592L38.7445 145.348Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.32 478.288L646.978 470.784L634.128 473.59L635.469 481.094L648.32 478.288Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364.23 830.128L1366.7 826.529L1361.61 823.43L1359.14 827.029L1364.23 830.128Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M858.588 408.26L865.026 403.446L855.717 392.612L849.279 397.426L858.588 408.26Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1189.1 227.132L1184.24 224.925L1178.55 233.799L1183.41 236.006L1189.1 227.132Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.605 681.446L473.738 676.894L460.376 656.942L452.243 661.494L465.605 681.446Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.678 491.271L381.408 487.141L375.636 483.64L372.906 487.77L378.678 491.271Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925.481 89.4877L918.769 87.175L912.855 101.031L919.567 103.344L925.481 89.4877Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.131 680.22L362.015 680.096L358.913 672.378L351.03 672.502L354.131 680.22Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.007 253.117L629.174 247.163L616.021 259.528L622.854 265.482L636.007 253.117Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427 449.34L1421.85 446.567L1418.88 453.157L1424.04 455.929L1427 449.34Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.98 344.262L910.302 342.409L905.782 353.112L910.46 354.965L914.98 344.262Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.498 607.44L895.591 604.061L882.845 588.841L877.752 592.22L890.498 607.44Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.71 55.9919L1249.61 51.9927L1238.84 60.4936L1242.94 64.4928L1253.71 55.9919Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.867 15.5234L364.154 10.8274L350.882 16.5757L353.595 21.2717L366.867 15.5234Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.851 660.841L488.469 659.646L490.001 666.019L495.383 667.214L493.851 660.841Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.944 568.235L749.227 563.553L739.763 571.867L745.48 576.549L754.944 568.235Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.85 468.626L1149.97 462.596L1133.25 454.032L1130.13 460.062L1146.85 468.626Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.043 873.664L974.298 868.598L967.446 872.952L971.191 878.019L978.043 873.664Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.667 115.772L948.087 112.538L936.386 129.274L942.966 132.508L954.667 115.772Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.257 803.45L804.282 795.571L793.991 792.314L792.967 800.193L803.257 803.45Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.593 526.855L572.838 520.361L557.178 535.655L563.932 542.149L579.593 526.855Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.64 444.321L1226.99 439.085L1207.59 424.88L1203.25 430.116L1222.64 444.321Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1434.06 87.615L1438.61 84.6333L1429.67 75.8113L1425.12 78.793L1434.06 87.615Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.007 277.729L619.204 271.178L607.214 264.696L603.017 271.248L615.007 277.729Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214.19 733.001L1218.56 732.346L1209.73 721.029L1205.37 721.684L1214.19 733.001Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.661 577.482L334.911 573.001L328.016 573.901L329.767 578.382L336.661 577.482Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.862 500.102L913.615 495.564L906.367 495.224L907.614 499.762L914.862 500.102Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.406 658.725L405.785 654.397L397.264 643.87L389.884 648.198L398.406 658.725Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.638 691.088L714.388 684.572L704.342 682.466L704.592 688.982L714.638 691.088Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.88 285.506L1011.15 283.331L1004.7 270.506L999.431 272.681L1005.88 285.506Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.112 540.427L207.167 538.097L203.904 546.408L208.849 548.738L212.112 540.427Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.941 43.0524L589.624 37.0986L574.328 52.6701L581.645 58.6239L596.941 43.0524Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5521 907.108L31.9741 899.989L12.808 896.907L12.386 904.027L31.5521 907.108Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.258 818.306L680.97 817.601L683.17 825.875L688.458 826.581L686.258 818.306Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.563 568.292L770.321 564.106L748.425 548.569L745.667 552.755L767.563 568.292Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1215.98 356.05L1222.61 352.514L1206.93 335.407L1200.3 338.943L1215.98 356.05Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.097 562.466L651.76 559.659L644.576 552.345L639.913 555.152L647.097 562.466Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.52 867.468L923.836 859.924L912.828 855.604L912.511 863.148L923.52 867.468Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1267.89 858.379L1262.25 851.36L1245.82 855.337L1251.46 862.356L1267.89 858.379Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.733 110.759L472.617 104.315L454.822 102.258L451.938 108.702L469.733 110.759Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.861 528.607L707.219 522.184L699.371 522.554L701.013 528.978L708.861 528.607Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.605 156.166L327.588 150.411L311.891 151.89L312.908 157.645L328.605 156.166Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.467 734.746L387.877 729.387L371.671 722.126L369.26 727.485L385.467 734.746Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1285.81 706.017L1292.43 704.344L1285.52 689.983L1278.89 691.656L1285.81 706.017Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.2 512.637L1258.83 510.833L1258.93 519.335L1264.3 521.139L1264.2 512.637Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.432 857.727L826.069 853.995L812.912 835.16L805.275 838.892L818.432 857.727Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.782 621.851L762.832 619.632L752.701 600.387L745.651 602.606L755.782 621.851Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.601 496.326L676.37 493.404L671.304 500.151L676.535 503.072L681.601 496.326Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.937 363.086L279.35 358.146L275.06 351.348L266.647 356.287L270.937 363.086Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.803 325.398L96.885 324.155L98.9017 303.643L90.8198 304.886L88.803 325.398Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.537 408.877L378.991 403.078L365.297 403.292L364.843 409.091L378.537 408.877Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.376 257.147L841.296 256.041L841.689 265.567L849.769 266.673L849.376 257.147Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.022 123.695L382.035 118.552L370.769 119.272L372.756 124.415L384.022 123.695Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.093 74.8425L146.306 68.7786L139.463 66.5714L137.25 72.6354L144.093 74.8425Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.875 173.43L361.551 167.973L354.171 170.401L356.496 175.858L363.875 173.43Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.889 749.988L354.333 747.718L354.358 758.247L359.914 760.516L359.889 749.988Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.225 595.403L909.98 590.203L902.385 599.348L909.629 604.549L917.225 595.403Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.492 245.853L872.611 246.746L870.064 233.616L864.945 232.723L867.492 245.853Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1201.27 721.077L1195.21 718.794L1192.79 724.77L1198.86 727.053L1201.27 721.077Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64934 488.621L9.3396 482.931L-1.75892 480.78L-3.44917 486.471L7.64934 488.621Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.516 268.497L349.902 261.563L329.6 270.863L334.213 277.797L354.516 268.497Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1323.61 116.979L1325.2 111.187L1309.54 110.445L1307.95 116.237L1323.61 116.979Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.291 67.6679L323.926 67.2932L316.465 54.2936L308.831 54.6683L316.291 67.6679Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.968 878.142L951.531 872.511L943.979 870.717L944.416 876.348L951.968 878.142Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.784 132.952L540.538 125.313L527.963 127.221L527.209 134.86L539.784 132.952Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.504 525.28L869.424 522.072L857.047 514.003L855.127 517.212L867.504 525.28Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.803 337.384L904.847 331.372L892.694 347.45L901.65 353.463L913.803 337.384Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.56 561.147L1246.46 555.271L1236.15 559.718L1240.25 565.595L1250.56 561.147Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.017 790.923L312.645 786.613L299.577 783.226L298.949 787.535L312.017 790.923Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.627 504.122L487.636 498.893L476.922 504.972L479.912 510.201L490.627 504.122Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.31 805.146L549.945 797.862L536.492 797.423L538.858 804.706L552.31 805.146Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.881 33.2484L640.352 25.8047L630.12 28.6506L634.649 36.0944L644.881 33.2484Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.622 828.004L575.915 823.436L567.099 806.144L558.806 810.712L567.622 828.004Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.424 916.896L634.254 913.844L617.67 896.474L612.84 899.526L629.424 916.896Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752.059 475.203L749.24 468.084L734.232 473.624L737.051 480.742L752.059 475.203Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.768 842.639L623.863 837.765L611.089 822.219L603.995 827.092L616.768 842.639Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322.62 778.71L1314.51 772.54L1303.63 785.831L1311.74 792.001L1322.62 778.71Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1299.84 497.78L1304.67 490.466L1291.06 483.605L1286.23 490.919L1299.84 497.78Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.352 212.246L273.003 210.795L270.964 227.891L280.314 229.342L282.352 212.246Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1255.16 799.176L1262.52 797.188L1250.31 783.276L1242.95 785.264L1255.16 799.176Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.922 46.1427L677.888 41.823L668.714 58.3673L676.748 62.687L685.922 46.1427Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.293 463.658L392.512 461.391L389.875 471.268L395.656 473.535L398.293 463.658Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.796 642.198L414.033 636.825L398.462 652.094L405.224 657.466L420.796 642.198Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.204 190.391L778.577 188.995L773.333 181.017L768.96 182.413L774.204 190.391Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140.28 506.488L1140.16 500.003L1128.67 497.607L1128.79 504.092L1140.28 506.488Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.939 798.837L713.881 796.224L715.361 803.612L723.418 806.225L721.939 798.837Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.89 531.868L1156.8 524.028L1140.75 525.079L1142.84 532.919L1158.89 531.868Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.02 184.595L1130.98 181.814L1123.89 173.678L1119.93 176.459L1127.02 184.595Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1098.25 468.455L1101.46 460.652L1085.86 455.352L1082.66 463.155L1098.25 468.455Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.06 354.685L1331.91 353.944L1336.6 371.889L1344.75 372.63L1340.06 354.685Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.207 648.088L235.659 646.492L235.691 655.338L245.239 656.935L245.207 648.088Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.554 799.673L610.813 796.423L602.582 787.458L598.323 790.707L606.554 799.673Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.683 846.706L359.39 841.223L349.851 851.413L357.143 856.896L366.683 846.706Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.194 345.806L619.083 340.065L606.19 349.541L611.301 355.282L624.194 345.806Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1114.29 660L1106.69 657.447L1102.72 669.541L1110.32 672.094L1114.29 660Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.537 263.842L607.553 260.325L602.125 266.547L607.108 270.063L612.537 263.842Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.758 197.657L695.377 192.548L683.112 187.418L681.493 192.526L693.758 197.657Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.231 315.762L428.323 310.791L420.446 312.622L421.354 317.593L429.231 315.762Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.37 704.161L1136.73 697.237L1121.5 712.634L1129.14 719.558L1144.37 704.161Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.211 371.371L246.734 367.546L235.73 380.183L241.208 384.009L252.211 371.371Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.62 872.984L1335.72 873.625L1334.35 865.815L1329.25 865.174L1330.62 872.984Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.572 398.477L680.103 395.496L675.008 409.28L681.477 412.262L686.572 398.477Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.18 417.964L1101.65 411.425L1079.57 400.032L1077.1 406.571L1099.18 417.964Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9683 715.343L71.8843 713.998L71.1576 725.94L76.2416 727.285L76.9683 715.343Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284.62 157.858L1275.69 156.511L1277.63 170.516L1286.56 171.863L1284.62 157.858Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.414 112.036L119.749 108.173L106.399 98.6024L103.064 102.465L116.414 112.036Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.944 702.022L845.871 699.069L839.965 692.761L836.038 695.714L841.944 702.022Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.935 357.243L714.153 352.916L707.879 351.215L706.661 355.542L712.935 357.243Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.808 59.3558L278.151 51.1328L268.049 53.1773L268.705 61.4003L278.808 59.3558Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.325 625.079L291.872 622.877L292.776 634.581L301.229 636.783L300.325 625.079Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.33 581.642L1008.56 575.846L995.377 567.905L992.149 573.701L1005.33 581.642Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1346.76 540.442L1348.13 536.576L1341.63 533.589L1340.26 537.455L1346.76 540.442Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7606 440.048L37.1267 438.08L33.7889 429.968L26.4228 431.936L29.7606 440.048Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.487 167.285L298.227 162.247L281.907 154.167L279.167 159.205L295.487 167.285Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.747 744.236L209.585 738.194L201.073 742.999L205.235 749.041L213.747 744.236Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1269.79 337.73L1266.94 330.48L1258.8 329.461L1261.64 336.711L1269.79 337.73Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.321 789.458L633.331 781.089L610.445 782.53L611.435 790.898L634.321 789.458Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.822 352.69L214.497 346.415L205.614 352.927L211.939 359.203L220.822 352.69Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.17 868.339L1098.65 865.624L1097.32 872.029L1102.85 874.744L1104.17 868.339Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.636 571.03L694.198 568.056L686.299 575.388L689.737 578.363L697.636 571.03Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045.7 414.552L1040.42 410.015L1035.55 414.267L1040.83 418.804L1045.7 414.552Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.599 119.709L738.104 113.26L723.647 114.162L723.142 120.611L737.599 119.709Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.693 465.737L532.981 460.65L521.786 469.136L526.498 474.223L537.693 465.737Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.807 626.578L805.583 621.941L795.488 624.541L798.712 629.178L808.807 626.578Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.531 816.491L925.512 817.544L925.521 807.118L920.54 806.065L920.531 816.491Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1425.87 244.492L1424.31 238.746L1413.82 240.263L1415.39 246.009L1425.87 244.492Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.173 763.513L977.218 757.478L968.695 760.891L972.651 766.926L981.173 763.513Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.72 432.681L1250.06 427.643L1235.94 421.502L1234.61 426.541L1248.72 432.681Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.773 370.243L964.768 368.744L958.814 355.673L953.82 357.172L959.773 370.243Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.821 656.163L464.264 650.515L446.296 638.907L441.853 644.555L459.821 656.163Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.112 657.157L341.886 652.899L329.245 656.669L330.471 660.926L343.112 657.157Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.87 615.554L1049.68 614.849L1046 605.948L1041.18 606.653L1044.87 615.554Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384.42 711.11L1375.78 710.975L1375.79 726.439L1384.43 726.574L1384.42 711.11Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.989 174.043L179.039 175.003L178.825 164.032L173.775 163.072L173.989 174.043Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045 758.177L1045.87 753.696L1033.85 752.167L1032.97 756.648L1045 758.177Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M826.684 562.531L819.856 555.855L811.736 562.046L818.564 568.722L826.684 562.531Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.006 354.103L281.701 353.184L278.287 341.756L269.592 342.675L273.006 354.103Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1371.42 533.451L1366.13 528.743L1357.69 536.232L1362.98 540.939L1371.42 533.451Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.739 890.871L230.382 884.084L219.088 892.579L226.445 899.366L237.739 890.871Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.498 596.794L220.623 596.346L223.319 611.078L229.194 611.526L226.498 596.794Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.191 703.732L513.068 701.125L509.913 691.864L501.035 694.471L504.191 703.732Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.358 451.886L375.699 447.679L358.385 429.323L352.044 433.53L369.358 451.886Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.079 879.826L515.379 873.973L505.765 873.234L508.466 879.086L518.079 879.826Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.587 688.464L288.205 686.098L277.337 677.317L274.719 679.683L285.587 688.464Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M803.698 351.78L800.549 344.839L792.778 347.154L795.927 354.094L803.698 351.78Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.939 829.752L756.579 824.975L749.943 819.813L745.302 824.591L751.939 829.752Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.489 794.515L445.573 790.04L435.893 781.5L430.809 785.975L440.489 794.515Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.56 415.083L100.563 409.263L82.6331 407.848L82.6306 413.669L100.56 415.083Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123.56 374.398L1129 371.268L1122.22 364.85L1116.78 367.98L1123.56 374.398Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.122 435.84L873.742 428.146L854.367 430.989L856.747 438.683L876.122 435.84Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.064 419.982L841.526 411.303L826.769 409.188L830.307 417.867L845.064 419.982Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.667 870.076L378.665 864.312L371.964 858.689L365.966 864.454L372.667 870.076Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1444.15 462.476L1450.45 458.197L1438.34 443.742L1432.05 448.021L1444.15 462.476Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408.5 55.3419L1400.38 51.2878L1394.97 59.7268L1403.09 63.7808L1408.5 55.3419Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.254 451.427L524.167 449.829L520.01 441.776L514.096 443.374L518.254 451.427Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.733 634.54L621.102 632.083L614.976 622.896L610.607 625.352L616.733 634.54Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.532 616.029L650.026 609.544L635.488 606.55L635.994 613.035L650.532 616.029Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.309 99.0013L494.319 93.8655L479.867 94.9888L479.857 100.125L494.309 99.0013Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.115 362.779L882.082 361.967L884.407 369.661L890.44 370.474L888.115 362.779Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.49 713.043L1142.59 707.427L1134.87 705.638L1135.77 711.254L1143.49 713.043Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.754 605.062L694.377 598.569L682.426 597.797L680.803 604.29L692.754 605.062Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.629 511.291L607.851 507.363L601.642 515.183L607.42 519.111L613.629 511.291Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.871 308.539L108.24 309.081L108.241 317.463L116.872 316.922L116.871 308.539Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.803 520.936L176.976 517.791L172.712 526.033L180.539 529.178L184.803 520.936Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1262.53 485.923L1262.53 481.456L1250.9 482.891L1250.9 487.358L1262.53 485.923Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.49 743.633L469.843 741.443L467.13 750.248L472.776 752.438L475.49 743.633Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.927 56.3521L257.004 48.1472L239.724 51.2143L242.647 59.4192L259.927 56.3521Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.99 416.892L1301 409.882L1290.81 408.148L1290.8 415.158L1300.99 416.892Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1152.4 301.984L1146.79 300.014L1145.6 304.889L1151.2 306.858L1152.4 301.984Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M941.116 709.3L938.237 704.791L930.756 708.54L933.634 713.049L941.116 709.3Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.647 336.24L704.793 331.746L695.708 341.332L701.562 345.826L710.647 336.24Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1276.84 626.659L1275.58 620.525L1258.53 625.884L1259.79 632.018L1276.84 626.659Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.936 135.374L516.422 133.799L512.983 127.484L506.496 129.058L509.936 135.374Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.901 533.599L642.526 527.657L629.91 535.967L634.286 541.909L646.901 533.599Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.14 531.567L732.801 524.978L713.1 526.986L715.439 533.575L735.14 531.567Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1420.25 394.188L1414.54 391.462L1410.16 402.367L1415.87 405.093L1420.25 394.188Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.524 433.519L900.714 426.628L888.215 424.025L886.025 430.916L898.524 433.519Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.837 304.122L864.935 300.39L858.874 291.03L851.776 294.762L857.837 304.122Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.37 75.318L1157.34 73.9944L1150.96 97.7801L1159.99 99.1037L1166.37 75.318Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.891 254.945L126.927 252.629L119.778 274.998L128.742 277.314L135.891 254.945Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.486 361.608L453.566 357.097L441.821 356.557L443.74 361.068L455.486 361.608Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.721 837.512L864.137 835.842L854.568 820.258L848.152 821.929L857.721 837.512Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.101 761.657L671.556 757.216L655.435 775.189L661.981 779.63L678.101 761.657Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.965 181.932L340.983 176.259L323.065 165.679L320.047 171.352L337.965 181.932Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1042.5 521.28L1039.08 516.505L1024.49 525.421L1027.91 530.196L1042.5 521.28Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.365 234.722L506.418 231.079L495.568 213.798L488.515 217.442L499.365 234.722Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1098.76 658.766L1094.58 652.86L1086.08 657.93L1090.26 663.837L1098.76 658.766Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.54 326.403L1180.9 327.613L1176.72 307.745L1167.36 306.535L1171.54 326.403Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290.72 72.3001L1299.69 71.1355L1295.67 61.5734L1286.7 62.738L1290.72 72.3001Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.289 219.801L420.618 216.671L416.817 227.757L424.488 230.887L428.289 219.801Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.911 506.757L289.45 504.714L287.236 500.704L282.697 502.747L284.911 506.757Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.72 519.618L1355.83 519.742L1354.58 532.694L1362.47 532.57L1363.72 519.618Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184 627.63L1185.04 622.385L1171.24 615.732L1170.2 620.977L1184 627.63Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.04 231.149L1071.21 227.369L1064.85 235.172L1070.68 238.951L1077.04 231.149Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.666 583.203L217.659 576.83L201.284 574.508L200.29 580.881L216.666 583.203Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.29465 394.667L3.81592 386.138L-10.4265 384.294L-9.94776 392.823L4.29465 394.667Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1173.5 417.103L1167.21 411.665L1159.69 419.172L1165.99 424.61L1173.5 417.103Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.566 728.001L387.33 722.215L371.259 719.835L373.495 725.621L389.566 728.001Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.68 16.6876L455.591 14.6631L449.668 35.9001L458.757 37.9247L464.68 16.6876Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.382 607.745L622.839 602.066L615.587 600.839L615.131 606.519L622.382 607.745Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1243.25 317.379L1243.66 310.307L1231.35 311.071L1230.94 318.143L1243.25 317.379Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.101 661.354L102.66 657.692L100.479 667.841L107.919 671.502L110.101 661.354Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.05 473.371L966.821 467.014L952.973 472.933L956.203 479.29L970.05 473.371Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.824 37.9917L591.981 34.9788L585.639 29.7204L582.481 32.7334L588.824 37.9917Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M954.982 261.912L948.776 258.584L942.167 266.55L948.373 269.878L954.982 261.912Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084.86 13.8178L1076.46 10.3022L1072.69 20.6518L1081.09 24.1674L1084.86 13.8178Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.062 222.695L197.374 222.843L194.734 214.383L185.423 214.235L188.062 222.695Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.294 352.82L390.519 348.042L380.604 357.506L386.38 362.284L396.294 352.82Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.165 63.9555L959.135 60.7422L951.158 52.4795L947.187 55.6928L955.165 63.9555Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.148 447.262H858.088L852.643 436.089H847.703L853.148 447.262Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.735 256.844L197.113 252.477L186.731 245.033L182.354 249.4L192.735 256.844Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.796 461.061L231.051 454.426L221.472 461.205L227.217 467.84L236.796 461.061Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.634 346.544L525.194 342.287L515.592 339.355L514.032 343.612L523.634 346.544Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.617 147.74L613.247 144.269L605.213 132.315L598.583 135.786L606.617 147.74Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1340.96 200.388L1333.9 199.381L1329.99 215.912L1337.05 216.919L1340.96 200.388Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.443 415.74L779.304 411.534L770.956 414.849L773.095 419.056L781.443 415.74Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.983 592.19L541.156 590.559L535.168 577.382L529.996 579.013L535.983 592.19Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.39 437.783L1029.14 435.512L1023.35 447.155L1028.6 449.426L1034.39 437.783Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.719 152.319L556.665 145.801L538.093 157.089L543.147 163.607L561.719 152.319Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.9 412.111L1178.72 410.948L1164.05 390.251L1157.23 391.414L1171.9 412.111Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793.713 896.934L791.352 888.666L776.231 891.896L778.592 900.165L793.713 896.934Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.89 585.949L500.848 582.345L497.038 587.349L502.08 590.953L505.89 585.949Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.331 167.753L896.198 161.36L885.615 163.051L886.748 169.444L897.331 167.753Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.953 751.88L369.057 748.594L354.289 732.657L349.185 735.943L363.953 751.88Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.945 570.204L860.652 566.797L856.531 561.897L851.823 565.305L855.945 570.204Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1231.4 619.767L1233.99 613.77L1217.54 604.608L1214.95 610.605L1231.4 619.767Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.505 266.008L540.989 262.921L526.446 253.789L524.963 256.876L539.505 266.008Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.741 623.895L233.826 618.33L222.291 621.167L223.205 626.732L234.741 623.895Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.595 819.182L619.077 813.409L600.704 812.288L602.222 818.06L620.595 819.182Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.259 299.212L435.324 298.838L437.92 313.749L445.855 314.122L443.259 299.212Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.92 328.541H1330.58L1330.6 349.836H1339.94L1339.92 328.541Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1115.94 878.123L1112.71 872.207L1102.98 873.769L1106.2 879.685L1115.94 878.123Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.711 897.739L700.926 889.835L689.838 896.332L698.623 904.236L709.711 897.739Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M818.773 313.839L825.478 309.866L810.135 293.775L803.431 297.747L818.773 313.839Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1345.13 848.399L1345.47 842.614L1336.96 840.107L1336.62 845.893L1345.13 848.399Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.096 750.997L154.859 747.866L144.893 732.112L138.129 735.243L148.096 750.997Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.011 433.93L548.602 429.844L543.442 439.393L550.851 443.48L556.011 433.93Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.01 556.666L1279.93 554.913L1274.75 567.564L1282.84 569.316L1288.01 556.666Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.187 777.407L411.175 771.034L395.477 768.433L396.489 774.805L412.187 777.407Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193.62 631.248L1202.33 629.797L1196.96 620.299L1188.26 621.75L1193.62 631.248Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.68 230.668L496.096 223.032L475.221 232.708L481.805 240.344L502.68 230.668Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.551 884.46L140.6 877.044L123.001 881.474L124.951 888.89L142.551 884.46Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1056.06 577.288L1051.1 571.604L1043.92 575.533L1048.87 581.217L1056.06 577.288Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1444.22 258.09L1446.56 251.805L1435.68 249.298L1433.35 255.583L1444.22 258.09Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208.85 477.842L1211.21 472.92L1205.9 471.416L1203.54 476.337L1208.85 477.842Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1373.72 535.692L1375.3 531.904L1365.59 526.401L1364.01 530.188L1373.72 535.692Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.235 748.306L797.9 741.072L789.988 746.421L797.322 753.655L805.235 748.306Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.185 405.757L102.162 404.087L97.1381 386.01L90.1612 387.68L95.185 405.757Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.68 819.61L1123.55 814.994L1112.2 806.979L1108.32 811.595L1119.68 819.61Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1398.69 569.096L1389.35 568.367L1387.6 586.309L1396.93 587.038L1398.69 569.096Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.433 472.908L456.761 471.939L450.555 462.825L446.228 463.794L452.433 472.908Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.268 572.573L727.897 572.086L723.382 564.144L718.754 564.631L723.268 572.573Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.79 883.029L1291.38 883.705L1292.14 874.046L1283.55 873.37L1282.79 883.029Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1207 254.056L1199.05 247.811L1186.61 260.787L1194.56 267.032L1207 254.056Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M842.512 567.51L851.024 568.206L847.094 545.001L838.581 544.305L842.512 567.51Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3972 496.488L83.5566 490.076L73.6156 491.498L74.4562 497.91L84.3972 496.488Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1069.33 830.788L1075.42 830.575L1072.35 819.703L1066.26 819.916L1069.33 830.788Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.191 671.277L421.333 665.769L413.186 659.342L408.044 664.851L416.191 671.277Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.17 741.347L613.355 734.496L595.671 729.234L593.486 736.085L611.17 741.347Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.683 402.678L322.541 394.907L298.899 394.534L299.041 402.305L322.683 402.678Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.088 411.018L701.045 406.197L691.181 416.904L697.223 421.724L707.088 411.018Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.533 661.572L853.111 655.643L840.566 670.805L847.988 676.734L860.533 661.572Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1433.57 564.333L1433.97 557.352L1415.86 554.554L1415.46 561.535L1433.57 564.333Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.836 515.183L141.182 511.333L127.078 500.117L123.732 503.967L137.836 515.183Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M825.106 274.541L832.231 270.484L819.794 256.408L812.67 260.465L825.106 274.541Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.294 48.944L855.154 46.4094L852.427 35.6049L844.567 38.1395L847.294 48.944Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.495 613.204L331.776 610.13L326.142 623.429L332.861 626.503L338.495 613.204Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.14 359.633L737.753 356.646L731.64 347.255L726.027 350.242L732.14 359.633Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089.82 868.109L1096.97 867.771L1096.29 860.67L1089.13 861.008L1089.82 868.109Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.088 802.071L345.255 800.227L341.629 793.621L336.462 795.465L340.088 802.071Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.87 566.026L1060.46 561.463L1051.26 552.275L1044.67 556.838L1053.87 566.026Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195.15 653.668L1195.27 648.743L1180.29 644.979L1180.17 649.904L1195.15 653.668Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.442 843.638L447.302 839.576L442.674 846.335L448.814 850.397L453.442 843.638Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.381 376.827L631.646 376.375L631.401 383.473L637.136 383.924L637.381 376.827Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1318.97 209.169L1323.8 207.84L1321.76 201.011L1316.92 202.34L1318.97 209.169Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1122.8 151.806L1126.55 150.104L1121.91 145.289L1118.16 146.991L1122.8 151.806Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.437 861.344L684.873 858.282L683.294 876.689L692.859 879.751L694.437 861.344Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.619 124.314L450.826 121.074L443.91 107.199L437.703 110.438L444.619 124.314Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.119 414.159L828.109 408.567L810.256 412.896L812.266 418.488L830.119 414.159Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.351 666.574L177.879 661.386L172.365 662.115L173.837 667.303L179.351 666.574Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.567 349.505L167.851 343.665L154.643 349.929L159.358 355.769L172.567 349.505Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.764 463.711L432.057 456.887L420.308 469.148L429.015 475.972L440.764 463.711Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1094.88 526.628L1101 523.999L1095.96 516.323L1089.83 518.952L1094.88 526.628Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.736 73.1539L474.311 69.4644L463.442 59.9798L458.868 63.6694L469.736 73.1539Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1365.6 337.123L1370.9 336.127L1364.47 323.311L1359.17 324.308L1365.6 337.123Z",
    fill: "#3EC1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.604 216.061L488.217 210.15L477.192 200.645L470.58 206.555L481.604 216.061Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.841 577.935L167.505 578.121L163.509 569.474L157.844 569.288L161.841 577.935Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.734 535.186L327.842 528.749L318.868 537.474L326.76 543.911L335.734 535.186Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.695 205.712L221.19 203.868L222.711 213.511L230.216 215.355L228.695 205.712Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.52 673.333L1055.7 669.079L1051.44 676.721L1059.26 680.975L1063.52 673.333Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.238 263.18L462.922 258.385L442.974 240.783L438.29 245.579L458.238 263.18Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M920.848 514.563L912.764 511.529L910.976 521.586L919.06 524.621L920.848 514.563Z",
    fill: "#F6F7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1241.94 286.73L1233.61 281.083L1225.42 292.179L1233.75 297.826L1241.94 286.73Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.486 795.362L232.024 790.107L218.645 790.543L219.107 795.798L232.486 795.362Z",
    fill: "#FF165D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.08 380.719H1298.24L1297.73 395.038H1305.57L1306.08 380.719Z",
    fill: "#FF165D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_955_35060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1443,
    height: 900,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfetti);
export default __webpack_public_path__ + "static/media/Confetti.2255e9524a1ef050a7b2a10f24153b50.svg";
export { ForwardRef as ReactComponent };